const $ = jQuery;
const $window = $(window);

const initNavigation = () => {
  const els = once('main-nav', '.om-navigation');
  els.forEach((el) => {
    const $nav = $(el);
    const $mainArrow = $nav.find('.on-dropdown-control');
    const $subArrow = $nav.find('.on-dropdown-control-sm');

    $mainArrow.click(function () {
      const $parent = $(this).closest('.on-top');

      if ($parent.hasClass('on-active')) {
        $parent.removeClass('on-active');
      } else {
        $('.on-top').removeClass('on-active');
        $parent.addClass('on-active');
      }
    });

    $subArrow.click(function () {
      const $parent = $(this).parent();

      if ($parent.hasClass('on-active')) {
        $parent.removeClass('on-active');
      } else {
        $parent.addClass('on-active');
      }
    });
  });
};

$window.on('load', () => initNavigation());
